import { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import initApp from 'utils/functions/init';
import { contexts } from 'constants/context';
import { status } from 'constants/general';
import { fetchPostsList } from 'modules/posts/actions';
import PostsView from 'modules/posts/views/PostsView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const PostsPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { companyProfilesList } = useSelector(state => ({
    companyProfilesList: state.common.companyProfilesList,
  }));

  const dispatch = useDispatch();

  const postsListApiCallBody = useRef({ limit: 10 });
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(contexts.posts);
  }, []);

  useEffect(() => {
    if (companyProfilesList.status === status.SUCCESS) {
      const body = {
        profileKey: sessionStorage.getItem('companyProfileKeyAuthCookie'),
        queryData: postsListApiCallBody.current,
        override: true,
      };
      dispatch(fetchPostsList(body));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyProfilesList]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <PostsView postsListApiCallBody={postsListApiCallBody} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

PostsPage.propTypes = {};

PostsPage.defaultProps = {};

export default PostsPage;
